import type { BoxProps } from "@mui/material"
import type { ReactNode } from "react"
import type { RequireAllOrNone } from "type-fest"
import { BackLink } from "../../navigation"
import { PageHeader } from "../PageHeader"
import {
  FullWidthHeaderLayout,
  type FullWidthHeaderLayoutBaseProps,
  TopTitleContainer,
} from "./common"

export type FullWidthHeaderProps = FullWidthHeaderLayoutBaseProps &
  RequireAllOrNone<{ linkLabel: string; linkTo: string }, "linkLabel" | "linkTo"> & {
    rightElement?: ReactNode
  } & Omit<BoxProps, "title">

export const FullWidthHeader = ({
  title,
  subtitle,
  chip,
  level = 1,
  rightElement,
  linkLabel,
  linkTo,
  ...boxProps
}: FullWidthHeaderProps) => (
  <FullWidthHeaderLayout {...boxProps}>
    {!!linkLabel && !!linkTo && (
      <TopTitleContainer left={(theme) => theme.spacing(-1)}>
        <BackLink to={linkTo}>{linkLabel}</BackLink>
      </TopTitleContainer>
    )}

    <PageHeader
      title={title}
      subtitle={subtitle}
      chip={chip}
      level={level}
      isFullWidth
    >
      {rightElement}
    </PageHeader>
  </FullWidthHeaderLayout>
)
